var _defs, _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPuzzleGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 803 550"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "puzzle_gray_svg__gradient_4",
    x1: 335161,
    y1: 412.66,
    x2: 314301,
    y2: 412.66,
    gradientTransform: "matrix(1 0 0 -1 0 550)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b1b1b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#717171"
  })), /*#__PURE__*/React.createElement("style", null, ".puzzle_gray_svg__cls-1{fill:#b6b6b6}.puzzle_gray_svg__cls-2{fill:#737373}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "puzzle_gray_svg__cls-1",
    d: "M587.94 111.78L434.19 23l-182.1 105.15-26.91-7.42v23l58.4 33.74c2.32-7.6 9-14.91 19.2-20.81 24.29-14 61.17-15.57 82.19-3.41 15 8.65 17.91 21.94 9.6 33.92l24.31 16.28 16 28.24 44.28-25.58v-23L429.44 186c-5.85-11.54.38-25.5 18-35.65 24.28-14 61.17-15.56 82.19-3.4 9.79 5.65 14.73 13.42 14.21 21.76l71.38-41.24v-22.91z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "puzzle_gray_svg__cls-2",
    d: "M543.8 86.28v80.35a18.74 18.74 0 010 2.12l71.38-41.23v-23l-27.26 7.22z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M420.19 181.78h7.69c-2.59-10.58 4.08-22.45 19.54-31.38 16.55-9.56 38.93-13.29 58.17-10.88V92.89h-85.4z",
    fill: "url(#puzzle_gray_svg__gradient_4)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "puzzle_gray_svg__cls-2",
    d: "M428.28 183.13h-22.09v65.12l73-42.16v-23l-49.72 2.92a19.34 19.34 0 01-1.17-2.92z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "puzzle_gray_svg__cls-1",
    d: "M392.75 188.2l-10.47.62h-39.23v23l63.14 36.47v-23z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M543.8 145.79l71.38-41.23L434.19 0l-209 120.73 58.4 33.74c2.32-7.6 9-14.91 19.2-20.82 24.29-14 61.17-15.56 82.19-3.41s18.39 33.46-5.9 47.49c-10.22 5.9-22.87 9.75-36 11.09l63.14 36.47 73-42.16c-14.44.3-27.88-2.54-37.67-8.2-21-12.16-18.39-33.46 5.9-47.49s61.17-15.55 82.19-3.4c9.76 5.65 14.69 13.41 14.16 21.75z",
    fill: "#f0f0f0"
  })));
}

export default SvgPuzzleGray;